import * as React from "react";

const SvgIcon = ({ size='24', color='white'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.4"
      d="M16.697 2.4A1.8 1.8 0 0 0 13.728.525l-10.8 10.8A1.8 1.8 0 0 0 4.198 14.4h4.803a.6.6 0 0 1 .565.8l-2.264 6.4a1.8 1.8 0 0 0 2.97 1.873l10.8-10.8A1.8 1.8 0 0 0 19.802 9.6h-4.797a.6.6 0 0 1-.567-.8Z"
    ></path>
  </svg>
);

export default SvgIcon;

